import BaseApi from './base.api'
class OrderApi extends BaseApi {
  supplierOrdersUrl = 'supplier-orders/'
  supplierOrderRowsUrl = 'supplier-order-rows/'
  supplierOrderReasonsUrl = 'supplier-order-reasons/'
  supplierOrderGroupsUrl = 'supplier-order-groups/'

  constructor() {
    super('order/')
  }

  batchDeleteSupplierOrdersAsync = (ids) => this.post(`${this.supplierOrdersUrl}batch-delete/`, { ids })
  batchDeleteSupplierOrderRowsAsync = (ids) => this.post(`${this.supplierOrderRowsUrl}batch-delete/`, { ids })

  getSupplierOrderDetailsAsync = (id, params, config = {}) => this.get(`${this.supplierOrdersUrl}${id}/details`, params, config)
  getSupplierOrdersAsync = (supplierOrderId = null) => this.get(`${this.supplierOrdersUrl}${supplierOrderId || ''}`)
  getSupplierOrderReasonsAsync = () => this.get(this.supplierOrderReasonsUrl)
  getSupplierOrderGroupsAsync = (params) => this.get(this.supplierOrderGroupsUrl, params)

  getSupplierOrderNextIdByDataAsync = (data) => this.post(`${this.supplierOrdersUrl}next/`, data)

  printSupplierOrdersAsync = (filename, data, config) => this.download(`${this.supplierOrdersUrl}print/`, filename, null, false, { ...config, method: 'post', data: data })
  printPreviewSupplierOrderAsync = (data) => this.downloadBlob(`${this.supplierOrdersUrl}print/`, null, false, { method: 'post', data: data })

  reorderSupplierOrderRowsAsync = (supplierOrderId, data) => this.post(`${this.supplierOrderRowsUrl}${supplierOrderId}/reorder_row_numbers/`, data)

  transmitSupplierOrdersAsync = (data) => this.post(`${this.supplierOrdersUrl}transmit/`, data)
}
export const orderApi = new OrderApi()
